import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { nextStepClicked } from "../../actions";
import { selectFormValue } from "../../selectors";
import { selectedAddress, duplexAddress } from "../../selectors/ServiceAddress";
import {
  selectCustomerDetail,
  selectworkSiteContactModel,
  selectSubmitModel,
} from "../../selectors/SubmitRequest";
//Components
import AddressInfo from "../Sections/SubmitRequest/AddressInfo";
import OffRampMessageSubmitRequest from "../Sections/SubmitRequest/OffRampMessageSubmitRequest";
import CostEstimate from "../Sections/SubmitRequest/CostEstimate";
import PreferredServiceWeek from "../Sections/SubmitRequest/PreferredServiceWeek";
import SubmitNotes from "../Sections/SubmitRequest/SubmitNotes";
import CustomerDetailsInfo from "../Sections/SubmitRequest/CustomerDetailsInfo";
import WorksiteContactInfo from "../Sections/SubmitRequest/WorksiteContactInfo";
import BuildingDetailsInfo from "../Sections/SubmitRequest/BuildingDetailsInfo";
import StepNavButtons from "../Sections/StepNavButtons";
import TextArea from "../Basic/TextArea";
import TextBox from "../Basic/TextBox";
import { selectProjectModel } from "../../selectors/ProjectSpecifics";
import { selectBusinessPartnerModel } from "../../selectors/CustomerDetails";

import util from "../../lib/util";
import * as consts from "../../constants";
import DatePicker from "../Enhanced/DatePicker";
// Import components
class SubmitRequest extends React.Component {
  constructor() {
    super();
    this.state = {
      isGetOffRampMessageCalled: false,
      isSaveProjectCalled: false,
      isSubmitProjectCalled: false,
    };
  }

  componentWillReceiveProps(p) {
    if (!this.state.isGetOffRampMessageCalled) {
      let submitPage = p.isLoggedIn ? 4 : 5;
      if (p.pageName == consts.NEW_GAS_LINE_NAME) submitPage = submitPage + 1;
      if (submitPage === p.activeIndex) {
        this.setState({ isGetOffRampMessageCalled: true });
        // get the offramp message from server
        p.onGetOffRampMessage();
      }
    }
    if (
      p.project &&
      p.project.isSuccess &&
      this.state.isSubmitProjectCalled &&
      p.project.isRequiredByUpdated
    ) {
      this.submitProject();
      this.setState({ isSubmitProjectCalled: false });
    }
    if (
      p.project &&
      p.project.isSuccess &&
      !this.state.isSaveProjectCalled &&
      p.project.isRouteToDashboard
    ) {
      util.routeToDashbord(p);
      this.setState({ isSaveProjectCalled: true });
    }
  }
  onSaveClick = () => {
    this.setState({ isGetOffRampMessageCalled: false });
    this.setState({ isSaveProjectCalled: false });
    const p = this.props;
    let model = p.projectModel;
    model.stepName = "dashboard";
    p.saveProject(model);
  };
  onSubmitRequest = () => {
    const p = this.props;
    if (p.offRampMessage) {
      const validators = [
        ["requiredByDate", (p) => p.requiredBy, "Preferred service date"],
      ];
      if (util.validate(validators, p, p.formError)) {
        let model = p.projectModel;
        model.stepName = "step7_submitrequest";
        this.setState({ isSubmitProjectCalled: true });
        p.saveProject(model);
      }
    } else {
      this.submitProject();
    }
  };
  submitProject = () => {
    const p = this.props;
    const lookup = window.osa.lookup.submitRequest;

    let model;
    if (p.pageName == consts.NEW_GAS_LINE_NAME) model = p.selectSubmitModel;
    else if (p.pageName == consts.SERVICE_REMOVAL_NAME) {
      model = {
        Project: p.projectModel,
        Customer: p.bupaModel,
        ReasonMsg: util.getNamebyId(lookup.reasonTypes.items, +p.reasonType),
        VacantMsg: util.getNamebyId(lookup.vacantTypes.items, +p.vacantType),
        DemolishReasonMsg:
          p.vacantType == "1"
            ? util.getNamebyId(
                lookup.demolishReasonTypes.items,
                +p.demolishReasonType
              )
            : null,
      };
    }

    model.pageName = p.pageName;
    p.onSubmitProject(model);
  };
  onBackClick = () => {
    const p = this.props;
    p.resetProjectSpecifics();
    this.setState({ isGetOffRampMessageCalled: false });
    let lastStep = p.project.skipSchedule ? 3 : 4;
    if (p.isLoggedIn) lastStep = lastStep - 1;

    if (p.pageName == consts.NEW_GAS_LINE_NAME) lastStep = lastStep + 1;
    p.onNextStepClicked(lastStep);
    p.setRenderSchedule(true);
  };

  render() {
    const p = this.props;
    const lookup =
      window.osa && window.osa.lookup && window.osa.lookup.submitRequest;
    return (
      <div>
        <div className="row">
          <div className="col-md-7">
            <div className="form-group">
              <h4 className="text-primary">Service request details</h4>
              <h4 className="text-primary">{lookup.addressInfoTitle}</h4>
              <AddressInfo address={p.address} />
              {p.isTwoMeter ? <AddressInfo address={p.address2} /> : null}
              {p.offRampMessage ? ( //project is offramp
                <div>
                  <OffRampMessageSubmitRequest
                    offRampMessage={p.offRampMessage}
                  />
                  <br />
                  <div className="row">
                    <div className="col-sm-6">
                      <DatePicker
                        id="requiredByDate"
                        className="newdatepicker"
                        name="requiredByDate"
                        required
                        title="Preferred service date"
                        pattern={consts.REGEX_DATE}
                        isOffRamp={true}
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <br />
                  <div>
                    {p.pageName === consts.NEW_GAS_LINE_NAME ? (
                      <div>
                        <div className="row">
                          <div className="col-sm-6">
                            <TextBox
                              title="Current heating system"
                              name="heatingSystem"
                            />
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-sm-6">
                            <TextBox
                              title="Age of property"
                              name="ageOfProperty"
                            />
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-sm-6">
                            <TextArea
                              title="Other information"
                              name="additionalNotes"
                            />
                          </div>
                        </div>
                        <br />
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-sm-6">
                          <TextArea
                            title="Additional Notes"
                            subTitle="(e.g. the best time to reach you)"
                            name="additionalNotes"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                //normal project with out any off ramp
                <div>
                  <CostEstimate
                    lookup={lookup}
                    vacantType={p.vacantType}
                    reasonType={p.reasonType}
                    cost={p.cost}
                  />
                  <PreferredServiceWeek scheduleDate={p.dateSelected} />
                  <SubmitNotes lookup={lookup} />
                </div>
              )}
            </div>
          </div>
          <div className="col-md-5">
            {!p.verifyAccountRetriesExceed ? (
              <div>
                <CustomerDetailsInfo
                  customerType={p.customerType}
                  customer={p.customerDetail}
                  onEditClicked={p.onEditCustomerDetailsInfoClicked}
                  resetProjectSpecifics={p.resetProjectSpecifics}
                />
                <br />
                <WorksiteContactInfo
                  customerType={p.customerType}
                  customer={p.customerDetail}
                  userAuthenticate={p.userAuthenticate}
                  workSiteContact={p.workSiteContact}
                  workSiteContactModel={p.workSiteContactModel}
                  resetProjectSpecifics={p.resetProjectSpecifics}
                  onEditClicked={p.onEditCustomerDetailsInfoClicked}
                  pageName={p.pageName}
                />
                <br />
              </div>
            ) : null}
            <BuildingDetailsInfo />
          </div>
        </div>
        <StepNavButtons
          text="Submit service request"
          onNextClick={this.onSubmitRequest}
          isShowSave={p.isLoggedIn}
          onSaveClick={this.onSaveClick}
          onBackClick={this.onBackClick}
          onCancelClick={p.onCancelClick}
        />
      </div>
    );
  }
}

SubmitRequest.propTypes = {
  onNextClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  project: PropTypes.object,
  isBPAuthenticated: PropTypes.bool,
  offRampMessage: PropTypes.string,
  dateSelected: PropTypes.string,
  projectModel: PropTypes.object,
  requiredBy: PropTypes.string,
  pageName: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
    onEditCustomerDetailsInfoClicked: (step) => dispatch(nextStepClicked(step)),
    onGetOffRampMessage: () => dispatch({ type: "GET_OFFRAMP_MESSAGE" }),
    onSubmitProject: (model) => dispatch({ type: "SUBMIT_PROJECT", model }),
    saveProject: (model) => dispatch({ type: "SAVE_PROJECT", model }),
    formError: (name, error) => dispatch({ type: "FORM_ERROR", name, error }),
    resetProjectSpecifics: () => dispatch({ type: "PROJECT_RESET_SUCCESS" }),
    setRenderSchedule: (value) =>
      dispatch({ type: "SET_IS_RENDER_SCHEDULE", value }),
  };
}
const mapStateToProps = (state) => {
  return {
    address: selectedAddress(state),
    address2: duplexAddress(state),
    isTwoMeter:
      state.form.buildingType == "2" && state.form.duplexMeterCount == "2",
    vacantType: selectFormValue(state.form, "vacantType"),
    reasonType: selectFormValue(state.form, "reasonType"),
    demolishReasonType: selectFormValue(state.form, "demolishReasonType"),
    customerType: selectFormValue(state.form, "customerType"),
    workSiteContact: selectFormValue(state.form, "workSiteContact"),
    customerDetail: selectCustomerDetail()(state),
    userAuthenticate: state.gas.user && state.gas.user.isAuthenticated,
    workSiteContactModel: selectworkSiteContactModel()(state),
    activeIndex: state.gas.activeIndex,
    offRampMessage: state.gas.offramp && state.gas.offramp.message,
    isBPAuthenticated: state.gas.offramp && state.gas.offramp.isBPAuthenticated,
    project: state.gas.project,
    dateSelected: state.gas.schedule && state.gas.schedule.dateSelected,
    projectModel: selectProjectModel(state),
    bupaModel: selectBusinessPartnerModel(state),
    requiredBy: state.form.requiredByDate,
    cost:
      state.gas.project &&
      state.gas.project.data &&
      state.gas.project.data.cost,
    pageName: state.gas.pageName,
    selectSubmitModel: selectSubmitModel(state),
    verifyAccountRetriesExceed: state.gas.verifyAccountExceed,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitRequest);
